import axios from 'axios'
import qs from 'qs'

import {Message, MessageBox} from 'element-ui'

axios.defaults.timeout = 1000000
axios.defaults.headers.common['Cache-Control'] = 'no-cache'
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'
axios.defaults.baseURL = process.env.NODE_ENV == 'development' ? '/api/' : '../../../'

axios.interceptors.request.use(config => {
  if (config.method === 'post') config.data = qs.stringify(config.data) 
  return config
}, error => {
  return Promise.reject(error)
})

function showMsg(msg) {
  const option = {
    message: msg,
    type: 'warning'
  }
  Message(option)
}

let reloadConfirmShow = false

export default function request(option) {
    return axios(option).then(res => res.data).then(res => {
      if (res.status == 0) {
        if (/重新登录/.test(res.msg)) {
          if (reloadConfirmShow) return
          reloadConfirmShow = true
          MessageBox.confirm(res.msg, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {top.location = window.location.origin})
          .catch(() => {})
        } {
          if (!option.notShowMsg) {
            showMsg(res.msg)
          }
        }
      }
      return res
    })
}
